import React from 'react';
import { getSelectedCompany, COMPANIES } from '../utils/companyUtils';

const CompanyIndicator = () => {
  const selectedCompany = getSelectedCompany();

  if (!selectedCompany) return null;

  const companyInfo = COMPANIES[selectedCompany.id] || selectedCompany;

  return (
    <div className="company-indicator" style={styles.indicator}>
      <span className="company-logo" style={styles.logo}>
        {companyInfo.logo}
      </span>
      <span className="company-name" style={styles.name}>
        {companyInfo.name}
      </span>
    </div>
  );
};

const styles = {
  indicator: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    background: 'rgba(255, 255, 255, 0.1)',
    padding: '4px 10px',
    borderRadius: '12px',
    fontSize: '12px',
    fontWeight: '500',
    color: 'rgba(255, 255, 255, 0.9)',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    marginRight: '16px'
  },
  logo: {
    fontSize: '14px'
  },
  name: {
    fontSize: '11px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  }
};

export default CompanyIndicator;
